module.exports = __webpack_public_path__ + "img/three.6bcbf1da.png";